import React, { useState } from 'react';
import logo from "../assets/images/logofooter.png";
import { Link, useNavigate } from 'react-router-dom';
import LoginModal from './LoginModal';

const MainFooter = () => {

    const navigate = useNavigate();
    const [loginModalshow, setLoginModalshow] = useState(false);
    const handleScrollToSection = (path, sectionId) => {
        navigate(path);
        setTimeout(() => {
            const element = document.getElementById(sectionId);
            if (element) {
                const offset = window.innerWidth <= 768 ? 300 : 100;
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }, 100);
    };
    const loginmodalpen = () => {
        setLoginModalshow(true);
        document.body.style.overflow = 'hidden';
      };

    return (
        <>
            <div className="container-fluid mt-5 mb-4">
                <div className="footersection">
                    <div className="row g-md-5">
                        <div className='col-md-5'>
                            <div className='footerimgcontain'>
                                {/* <img src={logo} alt='logo' /> */}
                                <h5 className='text-white mt-2'>Follow us on Social Media</h5>
                                <div className='footsociallink mt-2'>
                                    <Link to="/"><i className="bi bi-instagram"></i></Link>
                                    <Link to="/"><i className="bi bi-facebook"></i></Link>

                                    <Link to="/"><i className="bi bi-twitter"></i></Link>
                                    <Link to="/"><i className="bi bi-youtube"></i></Link>

                                </div>
                                {/* <p>Follow us on Social Media</p> */}


                            </div>
                        </div>
                        <div className='col-md-7'>
                            <div className='row  pb-3'>
                                <div className='col-md-4 col-12'>
                                    <div className='footernav'>
                                        <h5>Navigation</h5>
                                        <div className='botnav'>
                                            <Link onClick={() => handleScrollToSection("/", "about")} >About Us</Link>
                                            <Link onClick={() => handleScrollToSection("/", "WhatWeoffer")} >What We offer?</Link>
                                            <Link onClick={() => handleScrollToSection("/", "TypesofCars")} >Types of Cars</Link>
                                            <Link onClick={() => handleScrollToSection("/", "CarDetails")} >Car Details</Link>
                                            <Link onClick={() => handleScrollToSection("/", "WhereweOperate")} >Where we Operate</Link>
                                            <Link onClick={() => handleScrollToSection("/", "Reviews")} >Reviews</Link>
                                            <Link onClick={() => handleScrollToSection("/", "contact")} >Contact</Link>
                                            <Link  onClick={loginmodalpen}>Rent a Car</Link>

                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-8 col-12'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='footernav'>
                                                <h5>Type of Cars</h5>
                                                <div className='botnav'>
                                                    <Link onClick={() => handleScrollToSection("/", "TypesofCars")}>Maruti Suzuki Dezire</Link>
                                                    <Link onClick={() => handleScrollToSection("/", "TypesofCars")}>Toyota Innova Crysta</Link>
                                                    <Link onClick={() => handleScrollToSection("/", "TypesofCars")}>Mahindra Scorpio S11 MT</Link>

                                                </div>
                                            </div>
                                            <div className='contactinfo'>
                                                <h4>Contacts</h4>
                                                <Link to='mailto:info@viryawildlifetours.com'>info@viryawildlifetours.com</Link>
                                                <Link to='tel:+919870370353'>+91 9870 37 0353</Link>
                                                <Link to='tel:++919870474063'>+91 9870 47 4063</Link>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='footernav'>
                                                <h5>Explore More</h5>
                                                <div className='botnav'>
                                                    <Link to="https://viryawildlifetours.com/">Virya Wildlife Tours</Link>
                                                    <Link to="https://safari.viryawildlifetours.com/">Vrruksh Safaris</Link>
                                                    <Link to="https://holiday.viryawildlifetours.com/">Vrruksh Holidays</Link>

                                                </div>
                                            </div>
                                            <div className='contactinfo'>
                                                <h4>Address</h4>
                                                <Link>501, Floor 5, Plot No.345, Chandavar-kar Cross Road, Mumbai – 400019.</Link>
                                            </div>

                                        </div>
                                    </div>


                                </div>

                            </div>


                        </div>
                    </div>


                    <div className='row g-md-5'>
                        <div className='col-md-5 order-1 order-md-0 '>
                            <p className='mt-0 text-white mb-0 mt-3 text-center text-md-start'>© 2025. VIRYA WILDLIFE TOURS LLP.</p>
                        </div>
                        {/* <div className='col-md-7 order-0 order-md-1'>
                            <div className='footerprivacylink mt-3 pt-0'>
                                <ul>
                                    <li><Link to="/">Privacy Policies</Link></li>
                                    <li><i className="bi bi-circle-fill"></i></li>
                                    <li><Link to="/">Terms & Conditions</Link></li>
                                    <li><i className="bi bi-circle-fill"></i></li>
                                    <li><Link to="/">Cancellation & Refund Policy</Link></li>
                                </ul>
                            </div>
                        </div> */}


                    </div>
                </div>
            </div>
            <LoginModal setLoginModalshow={setLoginModalshow} loginModalshow={loginModalshow} />
        </>
    )
}

export default MainFooter;